import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";

const initialValue = {
  weight: null,
  nextWeight: null,
};

const AddRangeDialog = ({
  visible,
  onHide,
  onSubmit,
  loading = false,
  error = "",
}) => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    if (!visible) {
      setValue(initialValue);
    }
  }, [visible]);

  const footer = (
    <div>
      <Button label="Отменить" className="p-button-text" onClick={onHide} />
      <Button label="Добавить" loading={loading} onClick={() => onSubmit(value, () => setValue(initialValue))} />
    </div>
  );

  return (
    <Dialog header="Добавить диапазон" visible={visible} style={{ width: "32rem" }} onHide={onHide} footer={footer} modal>
      <div className="p-fluid" style={{ display: "grid", gap: "1rem" }}>
        <span className="p-float-label">
          <InputNumber
            inputId="range-weight"
            value={value.weight}
            onValueChange={(event) => setValue((current) => ({ ...current, weight: event.value }))}
            min={0}
            minFractionDigits={0}
            maxFractionDigits={2}
          />
          <label htmlFor="range-weight">Начало диапазона</label>
        </span>
        <span className="p-float-label">
          <InputNumber
            inputId="range-next-weight"
            value={value.nextWeight}
            onValueChange={(event) => setValue((current) => ({ ...current, nextWeight: event.value }))}
            min={0}
            minFractionDigits={0}
            maxFractionDigits={2}
          />
          <label htmlFor="range-next-weight">Конец диапазона</label>
        </span>
        {error ? (
          <div style={{ color: "#b42318", fontSize: "0.9rem" }}>{error}</div>
        ) : null}
      </div>
    </Dialog>
  );
};

export default AddRangeDialog;
